import { ToggleChip } from '@eventbrite/marmalade';
import React, { useRef } from 'react';
import styles from './categoryFilterBar.module.scss';
import { DateFilterDropdown } from './DateFilterDropdown';
import { useToggleStickyCarousel } from './hooks';
import { CategoryProps } from './interface';

export const CategoryFilterBar = (props: CategoryProps) => {
    const {
        categories,
        pageType,
        enableQuery,
        dateSelection,
        changeDateSelection,
        setCategoryTag,
        handleToggled,
        selectedCategory,
        enableDateFilter,
    } = props;
    const refs: Array<React.RefObject<HTMLButtonElement> | undefined> =
        categories.map(() => React.createRef());
    const scrollBarContainerRef = useRef<HTMLDivElement>(null);

    useToggleStickyCarousel(scrollBarContainerRef);

    const handleClick = (idx: number) => {
        enableQuery();
        handleToggled(idx);
        setCategoryTag(categories[idx].category);
    };

    return (
        <div id="scrollContainerId" ref={scrollBarContainerRef}>
            <div
                className={`${styles.categoryFilterBar} ${pageType}__carousel`}
            >
                {enableDateFilter ? (
                    <DateFilterDropdown
                        dateSelection={dateSelection}
                        changeDateSelection={changeDateSelection}
                        enableQuery={enableQuery}
                        pageType={pageType}
                    />
                ) : null}
                <div className={styles.carousel} id="chip-carousel">
                    <div className={styles.chips} id="scrollbar">
                        {categories.map((category, idx) => {
                            const selected = selectedCategory === category;
                            const toggledClassname = selected ? 'toggled' : '';
                            return (
                                <ToggleChip
                                    key={category.category.toString()}
                                    aria-label={category.category.toString()}
                                    data-heap-id={`${pageType}-CategoryFilterBar-${category.searchParam}`}
                                    className={`${styles.toggleChip} ${toggledClassname}`}
                                    iconTreatment="alwaysShow"
                                    onClick={() => handleClick(idx)}
                                    ref={refs[idx]}
                                    aria-pressed={selected}
                                    data-state={selected ? 'on' : 'off'}
                                >
                                    {category.category}
                                </ToggleChip>
                            );
                        })}
                    </div>
                </div>
            </div>
        </div>
    );
};
